module.exports = __webpack_public_path__ + "img/dep_household@3x.2939d7f3.png";